export enum TrailerType {
  TAUTLINER_13_6M_44FT = 'tautliner-13-6m-44ft',
  CONTAINER_13_6M_44FT = 'container-13-6m-44ft',
  MEGA_TRAILER_13_6M_44FT = 'mega-trailer-13-6m-44ft',
  BOX_13_6M_44FT = 'box-13-6m-44ft',
  REFRIGERATOR_13_6M_44FT = 'refrigerator-13-6m-44ft',
  FLATBED_13_6M_44FT = 'flatbed-13-6m-44ft',
  DOUBLE_DECKER_13_6M_44FT = 'double-decker-13-6m-44ft',
  HIGH_CUBE_OR_TALL_TRAILER = 'high-cube-or-tall-triler',
  HC_CONTAINER_5_9M_20FT = 'hc-container-5-9m-20ft',
  CONTAINER_12M_40FT = 'container-12m-40ft',
  HC_CONTAINER_12M_40FT = 'hc-container-12m-40ft',
  HC_CONTAINER_13_6M_45FT = 'hc-container-13_6m-45ft',
  MEGA_BOX_13_6M_44FT = 'mega-box-13-6m-44ft',
}

export enum WincantonTrailerTypes {
  TRACTION = 'traction',
  TALL_BOY_TRAILER = 'tall-boy-trailer',
  ARTIC_CRANE = 'artic-crane',
  BOX_TRAILER = 'box-trailer',
  BULK_TIPPER = 'bulk-tipper',
  CURTAIN_SIDE_TRAILER = 'curtain-side-trailer',
  DOUBLE_DECK_TRAILER = 'double-deck-trailer',
  DRAW_BAR = 'draw-bar',
  DRAW_BAR_26_3_MAX = 'draw-bar-26-3-max',
  DRAW_BAR_FLAT = 'draw-bar-flat',
  DRAW_BAR_MOFFETT = 'draw-bar-moffett',
  DRAW_BAR_CRANE = 'draw-bar-crane',
  FLAT_BED_TRAILER = 'flat-bed-trailer',
  MOFFETT = 'moffett',
  MOL = 'mol',
  PALLET_CARRIER = 'pallet-carrier',
  POWDER_TANKER = 'powder-tanker',
  URBAN_ARTIC_CRANE = 'urban-artic-crane',
  WALKING_FLOOR = 'walking-floor',
}

export enum RigidTrailerType {
  RIGID_26T = 'rigid-26t',
  RIGID_18T = 'rigid-18t',
  RIGID_7_5T = 'rigid-7-5t',
  RIGID_TANDEM_JUMBO = 'rigid-tandem-jumbo',
}
